const prefix = 'inactive-instance-banner';

export const i18n = {
    message: {
        id: `${prefix}.message`,
        defaultMessage: 'This instance is not active.',
    },
} as const;
